var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',[_c('el-tab-pane',{attrs:{"lazy":"","label":"接口权限"}},[_c('actions',{attrs:{"mode":_vm.mode,"target":_vm.target}})],1),_c('el-tab-pane',{attrs:{"lazy":"","label":"导航权限"}},[_c('modules',{attrs:{"mode":_vm.mode,"target":_vm.target}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }